/**
 * Batches are addressed by their own id, not by the event.
 *
 * One event can be dispatched more than once — a second round to people added
 * later — so an event-keyed cache would have the newer batch overwrite the one
 * still on screen.
 */
export const dispatchKeys = {
  all: ['dispatch'] as const,
  batches: () => [...dispatchKeys.all, 'batch'] as const,
  batch: (id: string) => [...dispatchKeys.batches(), id] as const,
  previews: () => [...dispatchKeys.all, 'preview'] as const,
  /**
   * Keyed on the SORTED ids, so the same set of events is the same cache entry
   * whatever order they were picked in — re-minting links because somebody
   * tapped two events the other way round would kill messages already copied.
   *
   * A preview narrowed to certain people is a DIFFERENT entry: it holds only
   * their messages, and serving it to the everyone-preview would drop the rest.
   */
  preview: (eventIds: string[], staffIds: string[] = []) =>
    staffIds.length === 0
      ? ([...dispatchKeys.previews(), [...eventIds].sort()] as const)
      : ([...dispatchKeys.previews(), [...eventIds].sort(), [...staffIds].sort()] as const),
  reports: () => [...dispatchKeys.all, 'report'] as const,
  report: (eventId: string) => [...dispatchKeys.reports(), eventId] as const,
  /** Keyed by TOKEN: the public page never learns the event id. */
  publicReport: (token: string) => [...dispatchKeys.reports(), 'public', token] as const,
  messages: () => [...dispatchKeys.all, 'message'] as const,
  /** One person's composed message on one event — what the copy button reads. */
  message: (eventId: string, staffId: string) =>
    [...dispatchKeys.messages(), eventId, staffId] as const,
  senderHealth: () => [...dispatchKeys.all, 'sender-health'] as const,
  messageQueue: () => [...dispatchKeys.all, 'message-queue'] as const,
};
